module.exports = __webpack_public_path__ + "static/img/area-icon6.6ac9b418.png";